<template>
  <div>
    <div class="side-frame-success d-flex mt-0 mb-2">
      <span style="font-size: 14px; color: #606266; line-height: 28px">
        {{ $l('table_label_sku_product_list') || 'SKU产品列表' }}
      </span>
      <SearchTabs
        class="ml-2"
        v-model="tab"
        :options="searchTabOpts"
        @change="changeTab"
      ></SearchTabs>
    </div>
    <b-row align-h="start">
      <b-col cols="4" style="padding-right: 7px">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_sku_search') ||
                  'SKU编号/NC/名称/颜色/尺寸 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
      <b-button
        v-if="allow('SK') && !disabled && tab == 'ALL'"
        size="sm"
        variant="outline-primary"
        @click="$emit('openEdit', { type: 'add' })"
        style="width: 91px"
      >
        {{ $l('btn_new_sku') || '新增SKU' }}
      </b-button>
      <el-badge
        v-if="allow('SS') && tab == 'Q'"
        :value="checkedRowCount"
        :hidden="!checkedRowCount"
        class="clearable-button"
        :class="{ clearable: !!checkedRowCount }"
        style="margin-bottom: 1px;"
      >
        <b-button
          class="ml-2"
          size="sm"
          variant="outline-primary"
          v-if="allow('SS') && tab == 'Q'"
          :disabled="!checkedRowCount"
          @click="$emit('informationReview')"
        >
          {{
            $l('btn_batch_submission_information_review') || '批量提交信息审核'
          }}
          <i
            class="el-icon-circle-close"
            @click.stop="$emit('clearCheckboxRow')"
          />
        </b-button>
      </el-badge>
      <el-badge
        v-if="allow('SG') && tab == 'C'"
        :value="checkedRowCount"
        :hidden="!checkedRowCount"
        class="clearable-button"
        :class="{ clearable: !!checkedRowCount }"
        style="margin-bottom: 1px;"
      >
        <b-button
          class="ml-2"
          size="sm"
          variant="outline-primary"
          v-if="allow('SG') && tab == 'C'"
          :disabled="!checkedRowCount"
          @click="$emit('purchasableApply')"
        >
          {{
            $l('btn_batch_submission_for_order_placement') || '批量提交转可下单'
          }}
          <i
            class="el-icon-circle-close"
            @click.stop="$emit('clearCheckboxRow')"
          />
        </b-button>
      </el-badge>
    </b-row>
  </div>
</template>

<script>
import SearchTabs from './tabs'
// 初始表单
const initForm = {
  keyword: '',
  evgSkuStatus: ['Q', 'Y'],
  listApplicationStatus: [],
  isVcList: [],
}
export default {
  props: {
    disabled: { type: Boolean, default: false },
    checkedRowCount: { type: Number, default: 0 },
  },
  components: { SearchTabs },
  data() {
    return {
      tab: 'ALL',
      form: { ...initForm },
    }
  },
  computed: {
    searchTabOpts() {
      return [
        {
          label: this.$l('tab_label_all') || '全部',
          value: 'ALL',
        },
        {
          label: this.$l('tab_label_planning') || '企划',
          value: 'Q',
        },
        {
          label: this.$l('tab_label_confirm') || '已确认',
          value: 'C',
        },
        // {
        //   label:  this.$l('tab_label_place') || '可下单',
        //   value: 'P',
        // },
        {
          label: this.$l('tab_label_formal') || '正式',
          value: 'Y',
        },
      ]
    },
  },
  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', {
        ...this.form,
        evgSkuStatus: this.tab == 'ALL' ? ['Q', 'Y', 'C'] : [this.tab],
      })
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    changeTab(value) {
      this.tab = value
      this.query()
      this.$emit('resetChecked')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}

.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid #67c23a;
}
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
